import styled, { css } from 'styled-components';

export const ModalStyled = styled.div`
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1000;
  margin: 0 auto;
  background: rgba(0, 0, 0, 0.2);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  &.open {
    opacity: 1;
    visibility: visible;
  }

  .commonModalInner {
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0.9);
    background: #ffffff;
    margin: 0 auto;
    transition: transform 0.3s ease;
  }

  &.open .commonModalInner {
    transform: translate(-50%, -50%) scale(1);
  }

  .closeBox {
    width: 100%;
    text-align: right;
    // position: absolute;
    // z-index: 999;
    // padding: 10px;
  }

  .closeImg {
    cursor: pointer;
  }
  .innerContents::-webkit-scrollbar {
    display: none;
  }

  .innerContents {
    // margin-top: 15px;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    width: 100%;
    height: 100%;
  }

  .textarea {
    margin: 20px 0px;
    width: 100%;
    height: 76px;
    padding: 8px;
    max-width: 100%;
    max-height: 76px;
    min-width: 100%;
    min-height: 76px;
  }
`;
